import SearchIcon from "@mui/icons-material/Search";
import { TextField } from "@mui/material";
import React, { useContext } from "react";

import { CollectionAssetsContext } from "../../../../providers/collection-assets-provider";

type Props = {
  label: string;
  type: number;
};

export default function CollectionSearch(props: Props): React.ReactElement {
  const { label, type } = props;
  const { filter, setFilter } = useContext(CollectionAssetsContext);

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setFilter({
      ...filter,
      name: {
        icontains: `%${event.target.value}%`,
      },
    });
  };

  return (
    <div className="relative w-full">
      <label className="absolute text-[12px] top-[7px] left-[15px] text-slate-500 z-10">
        {label}
      </label>
      <TextField
        className="shadow border-0 rounded-[15px] bg-white w-full"
        placeholder="Enter keyword"
        onChange={handleSearch}
        sx={{
          "& .MuiInputBase-input": { paddingTop: "24px", paddingBottom: "9px" },
          ".MuiOutlinedInput-notchedOutline": {
            border: 0,
            borderRadius: "15px",
          },
        }}
        InputProps={{
          endAdornment: (
            <SearchIcon className="text-[22px] text-slate-400 cursor-pointer" />
          ),
        }}
      />
    </div>
  );
}
